/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Explore
 *| (C) Copyright IBM Corp. 2018, 2019
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
import React, { Component } from 'react';
import { findDOMNode } from 'react-dom';
import PropTypes from 'util/PropTypes';
import { SearchInput } from 'ca-ui-toolkit';
import Dropdown from '../../dropdownMenu/Dropdown';
import { ShapingPickTree } from 'ca-modeller/shaping';

class FieldSearchInput extends Component {

	constructor(props) {
		super(props);

		this.filteredValues = [];

		//Use state for whether focus is in the control as it's a very transient property
		this.state = {
			inputValue: ''
		};
	}

	_shouldShowDropdown() {
		// if true, can render metadata tree
		return Boolean(this.state.inputValue && this.state.inputValue.length);
	}

	/*
	 * @return the actual Search Input from which the dropdown appears
	 */
	_renderSearchInput = (getTargetNode) => {
		return (
			<SearchInput
				placeholder= {this.props.placeholder}
				value={this.state.inputValue}
				onChange={this.onChange.bind(this)}
				ref= {
					(node) => {
						if(node) {
							this._searchInputRef = node;
							getTargetNode(node);
						}
					}
				}
			/>
		);
	}


	_renderDropdown() {
		const module = this.props.module;
		const shapingHelper = module.getShapingHelper();
		return (
			<shapingHelper.ShapingProvider>
				<ShapingPickTree
					filter={this.state.inputValue}
					onSelect={this.onSelect.bind(this)}
				/>
			</shapingHelper.ShapingProvider>
		);
	}

	render() {
		return (
			<Dropdown
				renderTrigger={this._renderSearchInput.bind(this)}
				renderDropdownContents={this._renderDropdown.bind(this)}
				open={this._shouldShowDropdown()}
				getDropdownMaxHeight={this.getDropdownMaxHeight.bind(this)}
				animationWhenContentChanges={false} // Need to set this prop to `false` to avoid the dropdown keep boucing when user types in the field input
			/>
		);
	}

	getDropdownMaxHeight() {
		if(this._searchInputRef) {
			/* eslint react/no-find-dom-node:"off" */
			//findDOMNode is required in this case. More info here:
			// https://github.com/facebook/react/issues/9217#issuecomment-287622539
			const searchInput = findDOMNode(this._searchInputRef);
			if(searchInput) {
				const { top, height } = searchInput.getBoundingClientRect();
				return window.innerHeight - height - top;
			}
		} else {
			return 0;
		}
	}

	onChange(value) {
		this.setState({
			inputValue: value
		});
	}

	onSelect(item) {
		this.props.onSelect && this.props.onSelect(item);
	}
}


FieldSearchInput.propTypes = {
	placeholder:PropTypes.string,
	module: PropTypes.observableObject.isRequired,
	onSelect: PropTypes.func
};

export default FieldSearchInput;



// WEBPACK FOOTER //
// ./src/js/components/startingPoints/relationshipGraph/FieldSearchInput.js